/**
 * PayoutReadinessPill — live-computed readiness indicator.
 * Phase 2D P3 (2026-04-24)
 *
 * Expects the activity object (or at minimum its payout_readiness field).
 * Reasons: no_evidence, not_approved, open_dispute, territory_blocked.
 */
import React from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";

const REASON_LABELS = {
  no_evidence: "no evidence",
  not_approved: "not approved",
  open_dispute: "open dispute",
  territory_blocked: "territory blocked",
};

export default function PayoutReadinessPill({ activity, compact = false }) {
  const pr = (activity && activity.payout_readiness) || null;
  if (!pr) return null;
  if (pr.ready) {
    return (
      <span
        data-testid="payout-readiness-ready"
        className="inline-flex items-center gap-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5 text-xs font-medium"
        title="Approved, evidence present, no blockers"
      >
        <CheckCircle2 className="w-3 h-3" /> Payout-ready
      </span>
    );
  }
  const reasons = (pr.reasons || []).map((r) => REASON_LABELS[r] || r);
  return (
    <span
      data-testid="payout-readiness-blocked"
      className="inline-flex items-center gap-1 rounded-full bg-slate-100 border border-slate-200 text-slate-600 px-2 py-0.5 text-xs font-medium"
      title={`Not ready: ${reasons.join(", ")}`}
    >
      <AlertCircle className="w-3 h-3" />
      {compact ? "Not ready" : `Not ready: ${reasons.join(", ")}`}
    </span>
  );
}
